import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { Text, Drawer, Carousel, Icon } from '@adc/ui-adc'
import Image1 from './remote-bid-1.png'
import Image2 from './remote-bid-2.png'
import Image3 from './remote-bid-3.png'
import cls from './styles.scss'

const cx = classNames.bind(cls)

const STATIC_SLIDE_CONTENTS = [
  {
    title: 'BID RIGHT WHERE YOU ARE',
    content:
      'Foreclosure auctions typically take place at organized in-person events. With REMOTE BID, you can participate online from anywhere!',
    img: Image1,
  },
  {
    title: 'REMOTE BID ON DESKTOP \n NOW AVAILABLE',
    content:
      'NOW offering Remote Bid from our mobile app AND your desktop. Simply log in to your Auction.com account and get qualified.',
    img: Image2,
    footer: 'Learn More',
    link: '/lp/remote-bid/',
  },
  {
    title: 'TAKE THE NEXT STEP',
    img: Image3,
    footer: `Visit your \n Remote Bid Dashboard`,
    link: '/dashboard/remote-bidding/',
  },
]

const baseElmId = 'remote_bid_drawer'

const NextArrow = ({ onClick, className }) => {
  const isDisabled = className.includes('slick-disabled')
  return (
    !isDisabled && (
      <div id='next' onClick={onClick} className={cx('arrow', 'next')}>
        <Icon
          name='angle-right'
          color='gray'
          iconStyle='regular'
          size='big'
          data-elm-id={`${baseElmId}_next_arrow`}
        />
      </div>
    )
  )
}

const BackArrow = ({ onClick, className }) => {
  const isDisabled = className.includes('slick-disabled')
  return (
    !isDisabled && (
      <div id='back' onClick={onClick} className={cls.arrow}>
        <Icon
          name='angle-left'
          color='gray'
          iconStyle='regular'
          size='big'
          data-elm-id={`${baseElmId}_back_arrow`}
        />
      </div>
    )
  )
}

NextArrow.propTypes = BackArrow.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
}

const RemoteBidDrawer = ({ onClose, className = '' }) => {
  const [userAgent, setUserAgent] = useState('desktop')

  useEffect(() => {
    navigator && setUserAgent(navigator.userAgent)
  }, [userAgent])

  return (
    <Drawer
      open
      onClose={onClose}
      elmId={baseElmId}
      closeOnDimmerClick
      headerStyle='clear'
    >
      <div className={cx('drawer-content', className)}>
        <Carousel
          elmId={`${baseElmId}_drawer`}
          settings={{
            dots: true,
            infinite: false,
            slidesToShow: 1,
            nextArrow: <NextArrow />,
            prevArrow: <BackArrow />,
          }}
        >
          {STATIC_SLIDE_CONTENTS.map(slide => {
            const { title, content, img, link, footer = null } = slide

            return (
              <div className={cls.slide} key={title}>
                <Text.Header
                  color='gray'
                  weight='400'
                  level='2'
                  className={cls.title}
                >
                  {title}
                </Text.Header>
                <div className={cls['image-wrapper']}>
                  <img src={img} className={cls.img} />
                </div>
                <div className={cls.content}>
                  <Text.Body weight='500' color='gray' size='large'>
                    {content}
                  </Text.Body>
                </div>
                <a href={link} target='_blank' rel='noreferrer'>
                  <Text
                    color={!link && 'gray'}
                    weight='medium'
                    size='big'
                    className={cls.footer}
                  >
                    {footer}
                  </Text>
                </a>
              </div>
            )
          })}
        </Carousel>
      </div>
    </Drawer>
  )
}

RemoteBidDrawer.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
}

export default RemoteBidDrawer
